import { render, staticRenderFns } from "./selectReading.vue?vue&type=template&id=539b02a5"
import script from "./selectReading.ts?vue&type=script&lang=js&external"
export * from "./selectReading.ts?vue&type=script&lang=js&external"
import style0 from "./selectReading.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports